import * as React from 'react';

function AlertCircle(props) {
    return (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", role: "presentation", focusable: "false", fill: "currentColor", viewBox: "0 0 16 16", className: "c-pieIcon c-pieIcon--alertCircle", width: "1em", height: "1em" }, props),
        React.createElement("path", { d: "M8 14.781A6.782 6.782 0 1 1 14.781 8 6.79 6.79 0 0 1 8 14.781Zm0-12.25A5.469 5.469 0 1 0 8 13.47 5.469 5.469 0 0 0 8 2.53Z" }),
        React.createElement("path", { d: "M7.055 4.631a3.5 3.5 0 0 1 1.89 0l-.481 4.244h-.928l-.481-4.244Zm1.82 5.994a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0Z" })));
}

export { AlertCircle as default };
